
import { Container, Sprite, Graphics } from 'pixi.js';

export class Photo extends Container {
    constructor(data) {
        super();
        this.rotationValue = Math.floor(Math.random() * 10) - 5;
        this.data = data;
        this.frame = new Sprite.from("album_frame");
        this.frame.angle = this.rotationValue;
        this.frame.anchor.set(0.5);
        this.maskSize = new Sprite.from("album_mask");
        this.masker = new Graphics();
        this.masker.beginFill(0x000000, 1);
        this.masker.drawRect(this.maskSize.x - (this.maskSize.width * 0.5), this.maskSize.y - (this.maskSize.height * 0.5), this.maskSize.width, this.maskSize.height);
        this.masker.endFill();
        this.masker.angle = this.rotationValue;
        this.addChild(this.masker);
        //this.masker.anchor.set(0.5);
        this.background = new Sprite.from(data.bg);
        this.background.anchor.set(0.5);
        this.background.angle = this.rotationValue;
        this.addChild(this.frame);
        this.addChild(this.background);
    }

    positionAvatar(avatar) {
        avatar.parent.removeChild(avatar);
        this.addChild(avatar);

        avatar.scale.set(this.data.charScale);
        // avatar.angle =  this.data.charRot;
        avatar.angle = this.rotationValue;
        avatar.position.set(this.data.charPos.x, this.data.charPos.y);

        avatar.mask = this.masker;
    }
}
